import Decimal from 'decimal.js';
import _ from 'lodash';

export const dec2fixed = decimal => decimal.toFixed(2).toString();

const transformVatRate = vatRate => {
  const set = new Set(['zw', 'np', 'vz']);
  if (set.has(vatRate)) {
    return '0';
  }

  return vatRate;
};

export const calculatePartialCost = (partialValue, totalValue, totalCost) => dec2fixed(new Decimal(partialValue) / new Decimal(totalValue) * new Decimal(totalCost)).toString();

export const recalculate = (name, value, quantity, grossPrice, netPrice, netValue, vatRate, vatAmount, grossValue, cost, totalValue = null, totalCost = null) => {
  if (name === 'quantity') {
    return quantityStrategy(value, grossPrice, netPrice, vatRate, vatAmount, cost, totalValue, totalCost);
  } else if (name === 'gross_price') {
    return grossPriceStrategy(value, quantity, vatRate, cost, totalValue, totalCost);
  } else if (name === 'net_price') {
    return netPriceStrategy(value, quantity, vatRate, totalValue, totalCost);
  } else if (name === 'vat_rate') {
    return vatRateStrategy(value, quantity, grossPrice, cost, totalValue, totalCost);
  } else if (name === 'cost') {
    return costStrategy(value, quantity, vatRate, grossPrice, totalValue, totalCost);
  }
};

const quantityStrategy = (value, grossPrice, netPrice, vatRate, vatAmount, cost, totalValue, totalCost) => {
  const newQuantity = value;
  let newGrossPrice = grossPrice;
  const newVatRate = vatRate;
  const newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
  let newCostValue = cost;
  let newNetPrice = netPrice;
  let newNetValue = '0.00';
  let newVatAmount = '0.00';
  if (cost !== false && !_.isNil(cost) && cost != '0.00') {
    if (totalValue && totalCost) {
      newCostValue = calculatePartialCost(newGrossValue, totalValue, totalCost);
    }
    newVatAmount = dec2fixed(new Decimal(newGrossValue - newCostValue) * (transformVatRate(newVatRate) / 100) / ((transformVatRate(newVatRate) / 100) + 1));
    if (newVatAmount < new Decimal('0')) {
      newVatAmount = new Decimal('0');
    }
    if (newGrossPrice == '') {
      newGrossPrice = '0.00';
    }
    newNetPrice = dec2fixed(new Decimal(newGrossPrice) - new Decimal(newVatAmount));
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
  } else {
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
    newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));
  }

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue, newCostValue };
};

const grossPriceStrategy = (value, quantity, vatRate, cost, totalValue, totalCost) => {
  const newQuantity = quantity;
  const newGrossPrice = value;
  const newVatRate = transformVatRate(vatRate);
  let newCostValue = cost;
  let newNetPrice = '0.00';
  let newGrossValue = '0.00';
  let newNetValue = '0.00';
  let newVatAmount = '0.00';
  console.log(cost);
  if (cost !== false && !_.isNil(cost) && cost != '0.00') {
    newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
    if (totalValue && totalCost) {
      newCostValue = calculatePartialCost(newGrossValue, totalValue, totalCost);
    }
    newVatAmount = dec2fixed(new Decimal(newGrossValue - newCostValue) * (transformVatRate(newVatRate) / 100) / ((transformVatRate(newVatRate) / 100) + 1));
    if (newVatAmount < new Decimal('0')) {
      newVatAmount = new Decimal('0');
    }
    newNetPrice = dec2fixed(new Decimal(newGrossPrice) - new Decimal(newVatAmount));
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
  } else {
    newNetPrice = dec2fixed(new Decimal(newGrossPrice / ((newVatRate / 100) + 1)));
    newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
    newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));
  }

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue, newCostValue };
};

const netPriceStrategy = (value, quantity, vatRate, totalValue, totalCost) => {
  const newQuantity = quantity;
  const newNetPrice = value;
  const newVatRate = vatRate;
  let newGrossPrice = '0.00';
  let newGrossValue = '0.00';
  let newVatAmount = '0.00';
  let newNetValue = '0.00';
  if (!isNaN(value)) {
    newGrossPrice = dec2fixed(new Decimal(newNetPrice).mul((transformVatRate(newVatRate) / 100) + 1));
    newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
    newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));
  }

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue };
};

const vatRateStrategy = (value, quantity, grossPrice, cost, totalValue, totalCost) => {
  const newVatRate = value;
  const newQuantity = quantity;
  const newGrossPrice = grossPrice;
  const newCostValue = cost;
  let newNetPrice = '0.00';
  let newGrossValue = '0.00';
  let newNetValue = '0.00';
  let newVatAmount = '0.00';
  if (cost !== false && !_.isNil(cost)) {
    newVatAmount = dec2fixed(new Decimal(newGrossPrice - newCostValue) * (transformVatRate(newVatRate) / 100) / ((transformVatRate(newVatRate) / 100) + 1));
    if (newVatAmount < new Decimal('0')) {
      newVatAmount = new Decimal('0');
    }
    newNetPrice = dec2fixed(new Decimal(newGrossPrice) - new Decimal(newVatAmount));
    newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
  } else {
    newNetPrice = dec2fixed(new Decimal(newGrossPrice / ((transformVatRate(newVatRate) / 100) + 1)));
    newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
    newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));
    newVatAmount = dec2fixed(new Decimal(newGrossValue - newNetValue));
  }

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue, newCostValue };
};

const costStrategy = (value, quantity, vatRate, grossPrice, totalValue, totalCost) => {
  const newCost = value;
  const newQuantity = quantity;
  const newGrossPrice = grossPrice;
  const newVatRate = vatRate;
  const newVatAmount = dec2fixed(new Decimal(newGrossPrice - newCost) * (transformVatRate(newVatRate) / 100) / ((transformVatRate(newVatRate) / 100) + 1));
  if (newVatAmount < new Decimal('0')) {
    newVatAmount = new Decimal('0');
  }
  const newNetPrice = dec2fixed(new Decimal(newGrossPrice) - new Decimal(newVatAmount));
  const newGrossValue = dec2fixed(new Decimal(newGrossPrice * newQuantity));
  const newNetValue = dec2fixed(new Decimal(newNetPrice * newQuantity));

  return { newQuantity, newGrossPrice, newNetPrice, newNetValue, newVatRate, newVatAmount, newGrossValue, newCost };

};
